import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import ProviderManager from '../../../provider/providerManager';
import { validateFields, validateField } from '../../../utilities/validation/validator';
import { regexPatterns, validationRules } from '../../../utilities/validation/validationVariables';
import lodash from 'lodash';
import { updateUserDetails, refreshToken } from '../../../utilities/authentication/authenticationSlice';
import {
  gAUpdateContactAndAccountDetailsPageLoadedWithBenefit,
  gAUpdateContactAndAccountDetailsPageLoadedWithoutBenefit,
  gAUpdateContactAndAccountDetailsWithBenefitCheckboxAgreeTermsChecked,
  gAUpdateContactAndAccountDetailsWithoutBenefitCheckboxAgreeTermsChecked,
  gAUpdateContactAndAccountDetailsWithBenefitSubmit,
  gAUpdateContactAndAccountDetailsWithoutBenefitSubmit,
  gAUpdateContactAndAccountDetailsSuccess,
  gAUpdateContactAndAccountDetailsFailed,
  gAUpdateContactAndAccountDetailsFailedBenefitIssue,
} from './gaReports';
import { setSubscribersDetails } from '../../Page/SelfCarePage/SelfCareSlice';

export const getContactAndAccountDetails = createAsyncThunk(
  'UpdateCustomerDetails/GetContactAndAccountDetails',
  async (blockId, thunkAPI) => {
    try {
      const result = await ProviderManager.getProviderData('getContactAndAccountDetails', [blockId]);

      return result;
    } catch (error) {
      return {
        error: true,
        reason: error,
      };
    }
  },
);

export const updateContactAndAccountDetails = createAsyncThunk(
  'UpdateCustomerDetails/UpdateContactAndAccountDetails',
  async (data, thunkAPI) => {
    try {
      const result = await ProviderManager.getProviderData('updateContactAndAccountDetails', data);

      if (result.Body.response.isSuccess == 'true') {
        const state = thunkAPI.getState().updateContactAndAccountDetails;
        if (state.form.firstName != state.contactDetails.firstName || state.form.lastName != state.contactDetails.lastName) {
          const payload = {
            firstName: state.form.firstName,
            lastName: state.form.lastName,
            cli: state.contactDetails.phone
          };
          thunkAPI.dispatch(updateUserDetails(payload));
          thunkAPI.dispatch(setSubscribersDetails(payload));
          thunkAPI.dispatch(refreshToken());
        }
      }
      return result;
    } catch (error) {
      return {
        error: true,
        reason: error,
      };
    }
  },
);

export const getCities = createAsyncThunk('addressForm/getCities', async (data, thunkAPI) => {
  try {
    const result = await ProviderManager.getProviderData('getCities', []);
    return result.Body;
  } catch (error) {
    return error;
  }
});

export const getStreets = createAsyncThunk('addressForm/getStreets', async (city, thunkAPI) => {
  try {
    const result = await ProviderManager.getProviderData('getStreetsByCity', [city]);
    return result.Body;
  } catch (error) {
    return error;
  }
});

const failedForm = {
  subMessageFailedForm: 'משהו הפריע לתהליך והפרטים לא עודכנו',
  isBenefitIssue: false,
};

const report = {
  isReadyForReport: false,
  isReported: false,
  progressType: 'תהליך 1',
};

const form = {
  isBenefitForm: false,
  firstName: '',
  lastName: '',
  isReady: false,
  cities: [],
  streets: [],
  entranceOptions: [
    { id: 1, key: 'ללא', value: 'ללא' },
    { id: 2, key: 'א', value: 'א' },
    { id: 3, key: 'ב', value: 'ב' },
    { id: 4, key: 'ג', value: 'ג' },
    { id: 5, key: 'ד', value: 'ד' },
    { id: 6, key: 'ה', value: 'ה' },
  ],
  report: report,
  isSuccessForm: false,
  isFailedForm: false,
  isCityWithoutStreets: false,
  isNotFoundError: false,
  isSelectedStreet: false,
  isSelectedCity: false,
  isSelectedEntrance: false,
  isEmailRequired: true,
  isAgreeDetails: false,
  isAgreeNews: false,
  isAgreeDetailsRequired: true,
  isChangedAgreeNews: false,
  isApartmentRequired: true,
  isEntranceRequired: true,
  city: '',
  email: '',
  cityName: '',
  street: '',
  streetName: '',
  home: '',
  apartment: '',
  enter: '',
  valid: '',
  errors: {},
  errorObj: '',
  entrance: 'בחר',
  failedForm: failedForm,
  addressData: { streetSemel: '', streetCode: '', citySemel: '', cityCode: '' },
  rules: {
    home: {
      required: { value: true, error: 'יש לבחור מספר בית' },
      pattern: { value: regexPatterns.numbersRegex, error: 'ערך לא תקין' },
    },
    apartment: {
      required: { value: true, error: 'יש לבחור מספר דירה בית' },
      pattern: { value: regexPatterns.numbersRegex, error: 'ערך לא תקין' },
    },

    email: {
      required: { value: true, error: 'שדה מייל הוא חובה' },
      pattern: { value: regexPatterns.emailRegex, error: 'ערך לא תקין' },
    },
    isAgreeDetails: {
      required: { value: true, error: 'חובה לאשר את התנאים' },
      pattern: { value: validationRules.checkboxRequired, error: 'ערך לא תקין' },
      checkboxRequired: { value: true, error: 'חובה לאשר את התנאים' },
    },
    firstName: {
      required: { value: true, error: 'שם פרטי הוא שדה חובה' },
      pattern: { value: regexPatterns.hardNameRegex, error: 'ערך לא תקין' },
    },
    lastName: {
      required: { value: true, error: 'שם משפחה הוא שדה חובה' },
      pattern: { value: regexPatterns.hardNameRegex, error: 'ערך לא תקין' },
    },
    // entrance: {
    //     required: {value: true, error: 'שדה כניסה הוא שדה חובה'},
    //     pattern: {value: '^(?!בחר$)', error: 'ערך לא תקין'},
    // },
  },
};

const initialState = {
  cities: [],
  streets: [],
  form: form,
  contactDetails: {
    benefit: null,
    contactId: '',
    updateDetailExposed: {},
    firstName: '',
    lastName: '',
    primaryEmail: '',
    phone: '',
    otherPhone: '',
    collaborationApproval: false,
    accounts: [
      {
        accountID: '',
        city: '',
        street: '',
        houseNo: '',
        apartment: '',
        entrance: '',
        adrType: '',
      },
    ],
  },
};

const updateContactAndAccountDetailsSlice = createSlice({
  name: 'updateContactAndAccountDetails',
  initialState: initialState,
  reducers: {
    resetBlock: (state) => initialState,
    setHomeNum: {
      reducer(state, action) {
        if (action.payload.HomeNum) {
          state.defaultHomeNum = action.payload.HomeNum;
          state.defaultApartment = action.payload.Apartment;
        }
      },
    },
    clearAddress: {
      reducer(state, action) {
        state.form = action.payload;
      },
      prepare(payload) {
        const form = lodash.cloneDeep(payload.form);
        form.streets = '';
        form.city = '';
        form.cityName = '';
        form.street = '';
        form.streetName = '';
        form.home = '';
        form.apartment = '';
        form.valid = '';
        form.isSelectedStreet = false;
        form.isSelectedCity = false;

        return { payload: form };
      },
    },
    setIsNotFoundError: {
      reducer(state, action) {
        state.form.isNotFoundError = action.payload.isNotFoundError;
      },
    },
    reportCheckboxAgreeTermsCheckedWithBenefit: () => {
      gAUpdateContactAndAccountDetailsWithBenefitCheckboxAgreeTermsChecked();
    },
    reportCheckboxAgreeTermsCheckedWithoutBenefit: () => {
      gAUpdateContactAndAccountDetailsWithoutBenefitCheckboxAgreeTermsChecked();
    },
    reportPageLoadedWithBenefit: () => {
      gAUpdateContactAndAccountDetailsPageLoadedWithBenefit();
    },
    reportPageLoadedWithoutBenefit: () => {
      gAUpdateContactAndAccountDetailsPageLoadedWithoutBenefit();
    },
    reportWithBenefitSubmit: (state, action) => {
      gAUpdateContactAndAccountDetailsWithBenefitSubmit(action.payload);
    },
    reportWithoutBenefitSubmit: (state, action) => {
      gAUpdateContactAndAccountDetailsWithoutBenefitSubmit(action.payload);
    },
    reportSuccess: (state, action) => {
      gAUpdateContactAndAccountDetailsSuccess(action.payload);
    },
    reportFailed: (state, action) => {
      gAUpdateContactAndAccountDetailsFailed(action.payload);
    },
    reportFailedBenefitIssue: (state, action) => {
      gAUpdateContactAndAccountDetailsFailedBenefitIssue(action.payload);
    },

    setIsShowPopUp: (state, action) => {
      state.isShowPopup = action.payload;
      return state;
    },
    setIsBenefitForm: (state, action) => {
      state.form.isBenefitForm = action.payload;
      return state;
    },
    setProgressType: (state, action) => {
      state.form.report.progressType = action.payload;
      return state;
    },

    setIsReadyForReport: (state, action) => {
      state.form.report.isReadyForReport = action.payload;
      return state;
    },
    setIsReported: (state, action) => {
      state.form.report.isReported = action.payload;
      return state;
    },
    validateHandler: {
      reducer(state, action) {
        state.form = action.payload;
      },
      prepare(payload) {
        const form = lodash.cloneDeep(payload);
        form.valid = '';
        const updatedForm = validateFields(form);

        if (updatedForm.valid) {
          //generate
        }
        return { payload: updatedForm };
      },
    },
    initValidation: {
      reducer(state, action) {
        state.form.valid = '';
      },
    },
    clearAddressDetails: {
      reducer(state, action) {
        state.form.isSelectedStreet = false;
        state.form.home = '';
        state.form.streetName = '';
        state.form.street = '';
        state.form.apartment = '';
      },
    },

    setIsFromBack: {
      reducer(state, action) {
        state.form.isFromBack = true;
      },
    },
    setIsValid: {
      reducer(state, action) {
        state.form.valid = action.payload;
      },
    },
    addressReportStep: {
      reducer(state, action) {
        state.currentStep = action.payload;
      },
    },
    handleCheckBox: {
      reducer(state, action) {
        if (action.payload != undefined && action.payload != null && action.payload.name != '') {
          switch (action.payload.name) {
            case 'isAgreeDetails':
              state.form.isAgreeDetails = action.payload.value;
              //Clear error from ui
              if (state.form.errors['isAgreeDetails'] != null && action.payload.value) {
                state.form.errors['isAgreeDetails'] = '';
              }
              break;

            case 'isAgreeNews':
              state.form.isAgreeNews = action.payload.value;
              state.form.isChangedAgreeNews = true;
              break;
          }
        }
      },
    },

    changeHandler: {
      reducer(state, action) {
        state.form = action.payload.form;
      },
      prepare(payload) {
        const name = payload.target.name;
        const value = payload.target.value;
        const form = lodash.cloneDeep(payload.form);

        if (value !== '' && name == 'entrance') {
          form.entrance = value;
          form.isSelectedEntrance = true;
        }

        if (value !== '' && name == 'apartment') {
          form.apartment = value;
        }

        if (name == 'firstName') {
          form.firstName = value;
        }

        if (name == 'lastName') {
          form.lastName = value;
        }

        if (value !== '' && name == 'enter') {
          const fiberData = lodash.cloneDeep(payload.fiberData);
          const tempArr = fiberData.apartments;
          const filteredArr = tempArr.filter((x) => x.entry === value);

          if (fiberData.apartments != undefined && fiberData.apartments.length != 0) {
            const validate = validateField(form, name, value);
            return { payload: { form: validate, infrastructureItem: filteredArr[0] } };
          }
        }

        if (value !== '' && name == 'city' && payload.form.cities.length != 0) {
          const filteredCity = payload.form.cities.filter((x) => x.cityCode === value);

          if (filteredCity.length > 0) {
            form.cityName = filteredCity[0].cityName;
            form.addressData.citySemel = filteredCity[0].citySemel;
            form.addressData.cityCode = filteredCity[0].cityCode;
            form.isNotFoundError = false;
            form.isSelectedCity = true;
            if (!form.isFromBack) {
              form.home = '';
              form.isFromBack = false;
            }
            form.apartment = '';
          } else {
            form.cityName = '';
            form.addressData.citySemel = '';
            form.addressData.cityCode = '';
            form.isNotFoundError = false;
            form.isSelectedCity = false;
            form.home = '';
            form.cityName = '';
            form.city = '';
            form.apartment = '';
            form.entrance = '';
            form.isSelectedEntrance = false;
          }
        }

        if (value !== '' && name == 'street' && payload.form.streets.length != 0) {
          const filteredStreet = payload.form.streets.filter((x) => x.streetCode === value);
          if (filteredStreet.length > 0) {
            form.streetName = filteredStreet[0].streetName;
            form.addressData.streetSemel = filteredStreet[0].streetSemel;
            form.addressData.streetCode = filteredStreet[0].streetCode;
            form.isNotFoundError = false;
            form.isSelectedStreet = true;
          } else {
            form.streetName = '';
            form.addressData.streetSemel = '';
            form.addressData.streetCode = '';
            form.street = '';
            form.isNotFoundError = false;
            form.isSelectedStreet = false;
          }
        }

        const validate = validateField(form, name, value);

        return { payload: { form: validate, fiberData: null } };
      },
    },
  },
  extraReducers: {
    [getContactAndAccountDetails.pending]: (state, action) => {
      console.log(action);
      return state;
    },
    [getContactAndAccountDetails.fulfilled]: (state, action) => {
      if (action.payload.Body != null && action.payload.Body.response != null) {
        state.contactDetails = action.payload.Body.response;
        state.form.firstName = state.contactDetails.firstName;
        state.form.lastName = state.contactDetails.lastName;
        state.form.email = state.contactDetails?.primaryEmail;
        state.form.isReady = true;
      } else {
        state.form.isFailedForm = true;
      }

      return state;
    },

    [updateContactAndAccountDetails.pending]: (state, action) => { },
    [updateContactAndAccountDetails.fulfilled]: (state, action) => {
      var response = action.payload.Body.response;
      if (response.isSuccess == 'true') {
        //Error form with benefit issue message
        if (response.isBenefitEntitled && !response.isBenefitSent) {
          state.form.isReady = false;
          state.form.isFailedForm = true;
          state.form.failedForm.isBenefitIssue = true;
          state.form.failedForm.subMessageFailedForm = 'הפרטים עודכנו אך ההטבה לא נשלחה';
        } else {
          state.form.isReady = false;
          state.form.isSuccessForm = true;
        }

        window.scroll(0, 0);
      } else {
        state.form.isReady = false;
        state.form.isFailedForm = true;
        window.scroll(0, 0);
      }
    },

    [getCities.fulfilled]: (state, action) => {
      if (action.payload.message !== '' && action.payload.message != undefined) {
        state.form.errorObj = { errorId: 0, message: action.payload.message };
      }

      state.form.cities = action.payload;
      state.cities = action.payload;
    },
    [getStreets.fulfilled]: (state, action) => {
      if (action.payload.length === undefined) {
        state.form.errorObj = { errorId: 0, message: action.payload.message };
      }

      if (state.form.city != '' && action.payload.length == 0) {
        state.form.streetName = state.form.cityName;
        state.form.isCityWithoutStreets = true;

        if (state.form.isCityWithoutStreets) {
          state.form.isSelectedStreet = false;
          state.form.isSelectedCity = false;
          state.form.home = '0';
          state.form.street = '0';
          state.form.apartment = 0;
          state.form.entrance = 'ללא';
        } else {
          state.form.isSelectedStreet = true;
          state.form.isSelectedCity = true;
          if (!state.form.isFromBack) {
            state.form.home = '';
            state.form.isFromBack = false;
          }
          state.form.street = '';
        }
      } else {
        state.form.streets = action.payload;
        state.streets = action.payload;
        state.form.isCityWithoutStreets = false;

        if (!state.form.isFromBack) {
          state.form.home = '';
          state.form.street = '';
          state.form.isFromBack = false;
        }
        if (state.defaultHomeNum != '' && state.defaultHomeNum != undefined) {
          state.form.home = state.defaultHomeNum;
          state.form.apartment = state.defaultApartment;
        }
      }
    },
    [getCities.rejected]: (state, action) => {
      state.form.isReady = false;
      state.form.isFailedForm = true;
      window.scroll(0, 0);
    },
    [getStreets.rejected]: (state, action) => {
      state.form.isReady = false;
      state.form.isFailedForm = true;
      window.scroll(0, 0);
    },
    [getContactAndAccountDetails.rejected]: (state, action) => {
      state.form.isReady = false;
      state.form.isFailedForm = true;
      window.scroll(0, 0);
    },
    [updateContactAndAccountDetails.rejected]: (state, action) => {
      state.form.isReady = false;
      state.form.isFailedForm = true;

      window.scroll(0, 0);
    },
  },
});

export const {
  setIsShowPopUp,
  setIsReported,
  setIsReadyForReport,
  changeHandler,
  validateHandler,
  clearAddress,
  initValidation,
  setIsNotFoundError,
  setHomeNum,
  resetBlock,
  setIsFromBack,
  setIsBenefitForm,
  setIsValid,
  reportAnalytics,
  clearAddressDetails,
  addressReportStep,
  handleCheckBox,
  reportCheckboxAgreeTermsCheckedWithBenefit,
  reportCheckboxAgreeTermsCheckedWithoutBenefit,
  reportPageLoadedWithBenefit,
  reportPageLoadedWithoutBenefit,
  reportWithBenefitSubmit,
  reportSuccess,
  reportFailed,
  reportWithoutBenefitSubmit,
  reportFailedBenefitIssue,
  setProgressType,
} = updateContactAndAccountDetailsSlice.actions;
export default updateContactAndAccountDetailsSlice.reducer;
